"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneITxBuildOutput = exports.txBuildOutToTxOut = void 0;
var cardano_ledger_ts_1 = require("@harmoniclabs/cardano-ledger-ts");
var CanBeData_1 = require("../utils/CanBeData.js");
function txBuildOutToTxOut(_a) {
    var address = _a.address, value = _a.value, datum = _a.datum, refScript = _a.refScript;
    return new cardano_ledger_ts_1.TxOut({
        address: typeof address === "string" ? cardano_ledger_ts_1.Address.fromString(address) : address.clone(),
        value: value instanceof cardano_ledger_ts_1.Value ? value.clone() : new cardano_ledger_ts_1.Value(value),
        datum: (0, CanBeData_1.canBeData)(datum) ? (0, CanBeData_1.forceData)(datum) :
            ((0, cardano_ledger_ts_1.canBeHash32)(datum) ? new cardano_ledger_ts_1.Hash32(datum) : undefined),
        refScript: refScript
    });
}
exports.txBuildOutToTxOut = txBuildOutToTxOut;
function cloneITxBuildOutput(_a) {
    var address = _a.address, value = _a.value, datum = _a.datum, refScript = _a.refScript;
    return {
        address: typeof address === "string" ? cardano_ledger_ts_1.Address.fromString(address) : address.clone(),
        value: value instanceof cardano_ledger_ts_1.Value ? value.clone() : new cardano_ledger_ts_1.Value(value),
        datum: (0, CanBeData_1.canBeData)(datum) ? (0, CanBeData_1.forceData)(datum) :
            ((0, cardano_ledger_ts_1.canBeHash32)(datum) ? new cardano_ledger_ts_1.Hash32(datum) : undefined),
        refScript: refScript === undefined ? undefined : refScript.clone()
    };
}
exports.cloneITxBuildOutput = cloneITxBuildOutput;
